export const mockParticipantId = 'mock-participant-id';
export const previewMockUserStudy = 'preview-mock-id';
